import Guid from "common/values/guid/guid";
import Forum from "messaging/entities/forum/forum";
import SubscriberAPIResponse from "messaging/values/subcriber/api/response-contracts/subscriber-api-response";
import Topic from "messaging/values/topic";
import moment from "moment";

export default class ForumAPIResponse {
  id?: string;
  name?: string;
  entityClass?: string;
  entityId?: string;
  context?: string;
  createdDate?: string;
  subscribers?: SubscriberAPIResponse[];
  creator?: SubscriberAPIResponse;
  numUnreadMessages?: number;

  deserialize(): Forum {
    if (!this.id) {
      throw new Error("Forum id not returned.");
    }

    const topic = new Topic(
      this.entityClass, 
      this.entityId ? new Guid(this.entityId) : undefined, 
      this.context
    );
    
    return new Forum(
      this.name,
      topic,
      this.subscribers?.map((s) => Object.assign(new SubscriberAPIResponse(), s).deserialize()),
      new Guid(this.id),
      this.creator ? Object.assign(new SubscriberAPIResponse(), this.creator).deserialize() : undefined,
      moment(this.createdDate),
      this.numUnreadMessages
    );
  }
}
